import { Axios } from '@/config/axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  // eslint-disable-next-line no-unused-vars
  getSecretQuestions({commit}) {
    return new Promise((resolve, reject) => {
      Axios.get('/api/account/get-secret-questions')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  getModifyInfos({commit}) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/account/get-modify-infos')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  saveInfos({commit}, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/account/save-infos', data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  validateSecretQuestions({commit}, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/account/validate-secret-questions', data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  resendOtpSaveInfos({commit}, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/account/resend-otp-save-infos', data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  validateOtpSaveInfos({commit}, data) {
    return new Promise((resolve, reject) => {
      Axios.post('/api/account/validate-otp-save-infos', data)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
